/** Faint red side-gradient wash behind the landing page (darker L/R edges, white middle). */
export function BackgroundGlows() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0"
      style={{
        background:
          "linear-gradient(to right, hsl(359 100% 71% / 0.05) 0%, hsl(359 100% 71% / 0.0125) 35%, hsl(359 100% 71% / 0.0125) 65%, hsl(359 100% 71% / 0.05) 100%)",
      }}
    />
  );
}
